class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.notificationWrapper = this.notification.parentElement;
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.mediaQuery = window.matchMedia('(max-width: 750px)');
    this.checkoutButton = this.querySelector('[name="checkout"]');
    this.checkoutButtonTitle = this.checkoutButton.getAttribute('title');
    this.termsInput = this.querySelector('#CartAttribute_terms-and-conditions');
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    if (this.termsInput.hasAttribute('required')) {
      this.termsInput.checked?this.checkoutButton.removeAttribute('disabled'):this.checkoutButton.setAttribute('disabled', true);
      this.termsInput.checked?this.checkoutButton.removeAttribute('title'):this.checkoutButton.setAttribute('title', this.checkoutButtonTitle);
      let self = this;
      this.termsInput.addEventListener('click', function() {
        self.termsInput.checked?self.checkoutButton.removeAttribute('disabled'):self.checkoutButton.setAttribute('disabled', true);
        self.termsInput.checked?self.checkoutButton.removeAttribute('title'):self.checkoutButton.setAttribute('title', self.checkoutButtonTitle);
      });
    }
    this.notificationWrapper.classList.add('active');
    this.notification.classList.add('animate', 'active');    

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.notificationWrapper.classList.remove('active');

    window.setTimeout(() => this.notification.classList.remove('animate'), 300);

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'help-bar',
        section: 'help-bar',
        selector: '.help-bar__list-item--free-shipping'
      }
    ];
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (this.header && this.mediaQuery.matches) this.header.reveal();
    this.open();
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
